export default __webpack_public_path__ + "static/media/pong.49d266ed.png";